var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 43,
    viewBox: "0 0 28 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.22461V41.775M24.1376 7.30717H8.9312C7.04914 7.30717 5.24416 8.05482 3.91335 9.38563C2.58253 10.7165 1.83488 12.5214 1.83488 14.4035C1.83488 16.2856 2.58253 18.0905 3.91335 19.4213C5.24416 20.7522 7.04914 21.4998 8.9312 21.4998H19.0688C20.9509 21.4998 22.7558 22.2475 24.0867 23.5783C25.4175 24.9091 26.1651 26.7141 26.1651 28.5961C26.1651 30.4782 25.4175 32.2832 24.0867 33.614C22.7558 34.9448 20.9509 35.6925 19.0688 35.6925H1.83488",
    stroke: "white",
    strokeWidth: 2.02752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.344b81a10ca5e4c7c527732c27941dfd.svg";
export { ForwardRef as ReactComponent };